<template>
  <div class="dim-number">

    <TrendIcon  v-if="this.params.value || this.isPercentValue()" :Difference="this.trend" class="dim-rect"/>

    {{ this.getValue(this.params.value) }} 
    
    <AccomplishmentIcon v-if="hasAccomplished() && !this.params.data.hideLink" 
                        :isAccomplished="isAccomplished()" />

    <div v-if="this.params.value && this.rowProperty && getSurveyInstance() && !this.params.data.hideLink" class="viewcheckreport">
      <b-button variant="outline-secondary" 
                @click="downloadReportForSurveyInstance(getSurveyInstance())"
                size="sm" 
                v-b-tooltip.hover.nofade="toolTipDelay" 
                :title="$t('Webportal.CX.Margin.DownloadCheckReportTooltip')">
        <small>
          <font-awesome-icon :icon="['fas', 'file-pdf']" />
        </small>
      </b-button>
    </div>
  </div>
</template>

<script>
import AccomplishmentIcon from "@/components/Shared/AccomplishmentIcon";
import CellRendererMixin from '@/mixins/jlr/CellRendererMixin';
import DownloadFileMixin from '@/mixins/DownloadFileMixin';
import TrendIcon from "@/components/Shared/TrendIcon";

export default {
  mixins: [ 
    CellRendererMixin, DownloadFileMixin 
  ],

  components: {
    AccomplishmentIcon, TrendIcon
  },
    
  methods: {
    hasValue() {
      if (this.params.value) return true;
      else if (this.params.value === undefined) return false;
      else if (this.params.value === null) return true;
      else return this.params.value.toString().trim().length > 0;
    },

    isPercentValue() {
      return _.includes(this.getValue(this.params.value), '%');
    },

    getValue(raw) {
      if (raw === 0) return '0%';
      else if(!raw) return;
      else return raw + "%"
    },

    getColor(arg) {
      let num = parseFloat(arg)
      if (num < 60) return '#FF2832';
      if (num < 80) return '#FFFF79';
      return '#A0D28F';
    }
  }
}
</script>

<style lang="scss" scoped>
  .dim-number {
    display: grid;
    grid-template-columns: auto 1fr 1fr 1fr;
    grid-template-rows: 1.5rem 1rem;
    grid-gap: 0.5rem;
    max-width: 8.0rem;
    width: 100%;
    height: 100%;
  }

  .dim-rect {
    width: 14px;
    margin: 0.87rem 0.0rem 0.0rem 0rem ;
    height: 14px;
    border-radius: 2px;
    margin-left: 6px
  }
</style>